<script setup>
import { computed, onMounted, ref } from 'vue'
import DataLayer from '@services/data-layer/index'
import ChannelDetailBlock from '@components/channel/channel-detail-block'
import { useStore } from '@composables/use-store'

const CHANNELS_ORDER = ['chill', 'classics', 'deep', 'frisky']

const store = useStore()

const channels = ref([])

const playlists = computed(() => store.state.nowPlaying.byStation)

onMounted(() => {
    DataLayer.channels.get().then(response => {
        channels.value = Object.values(response.body).sort(
            (a, b) => CHANNELS_ORDER.indexOf(a.id) - CHANNELS_ORDER.indexOf(b.id)
        )
    })
})
</script>

<template>
    <div>

        <BaseSection
            v-if="channels?.length"
            title="Radio"
        >
            <ChannelDetailBlock
                :channels="channels"
                :playlists="playlists"
                display-minimal-version
            />
        </BaseSection>
        <BaseSection
            v-else
            class="skeleton"
        >
            <div
                v-for="i in 4"
                :key="i"
                class="skeleton-tile"
            >
                <BasePlaceholder
                    type="channel"
                    tag="h6"
                    class="skeleton-title"
                />
                <div class="skeleton-cover" />
            </div>
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.skeleton {
    display: grid;
    grid-template-columns: 1fr;
    gap: $s-m;

    @include tablet {
        grid-template-columns: repeat(2, 1fr);
    }

    @include desktop {
        grid-template-columns: repeat(4, 1fr);
    }
}

.skeleton-title {
    margin: $s-s 0;
    text-align: center;
}

.skeleton-cover {
    height: 230px;
    background: currentColor;
    border-radius: 2px;
    opacity: 0.1;
}
</style>
